(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('cstm-product-form');
    if (!form) return;

    // --- Start: Elemen-elemen form ---
    const quantityInput = form.querySelector('input[name="quantity"]');
    const decrementBtn = form.querySelector('.cstm-quantity-btn[data-action="decrement"]');
    const incrementBtn = form.querySelector('.cstm-quantity-btn[data-action="increment"]');

    // Input yang dilihat pengguna
    const fullNameInput = form.querySelector('#CustomForm-FullName');
    const emailInput = form.querySelector('#CustomForm-Email');
    const phoneInput = form.querySelector('#CustomForm-Phone');

    // Input tersembunyi
    const firstNameInput = form.querySelector('input[name="contact[first_name]"]');
    const lastNameInput = form.querySelector('input[name="contact[last_name]"]');
    const tagsInput = form.querySelector('input[name="contact[tags]"]');
    // --- End: Elemen-elemen form ---

    decrementBtn.addEventListener('click', () => {
      let currentValue = parseInt(quantityInput.value, 10);
      if (currentValue > 1) {
        quantityInput.value = currentValue - 1;
      }
    });

    incrementBtn.addEventListener('click', () => {
      let currentValue = parseInt(quantityInput.value, 10);
      quantityInput.value = currentValue + 1;
    });

    form.addEventListener('submit', async function (event) {
      event.preventDefault();

      // --- 1. Memproses Nama ---
      const fullName = fullNameInput.value.trim();
      const nameParts = fullName.split(' ').filter((part) => part !== '');
      const firstName = nameParts[0] || '';
      const lastName = nameParts.slice(1).join(' ') || '';
      firstNameInput.value = firstName;
      lastNameInput.value = lastName || firstName;

      const submitButton = form.querySelector('button[type="submit"]');
      const spinner = submitButton.querySelector('.cstm-loading-spinner');
      const messagesDiv = document.getElementById('cstm-form-messages');

      submitButton.disabled = true;
      spinner.style.display = 'inline-block';
      messagesDiv.textContent = '';
      messagesDiv.className = 'cstm-form-messages tw-text-center tw-mb-4 tw-p-3 tw-rounded';

      const cartData = {
        items: [
          {
            id: form.querySelector('select[name="id"]').value,
            quantity: quantityInput.value,
          },
        ],
      };

      try {
        const cartResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(cartData),
        });
        const cartResult = await cartResponse.json();
        if (!cartResponse.ok) {
          throw new Error(cartResult.description || 'Could not add item to cart.');
        }

        const contactFormData = new FormData();
        contactFormData.append('form_type', form.querySelector('input[name="form_type"]').value);
        contactFormData.append('utf8', form.querySelector('input[name="utf8"]').value);

        contactFormData.append('contact[email]', emailInput.value);
        contactFormData.append('contact[phone]', phoneInput.value); // <-- PENTING: Menambahkan nomor telepon secara eksplisit
        contactFormData.append('contact[first_name]', firstNameInput.value);
        contactFormData.append('contact[last_name]', lastNameInput.value);
        contactFormData.append('contact[tags]', tagsInput.value);

        const contactResponse = await fetch('/contact', {
          method: 'POST',
          body: contactFormData,
        });

        if (!contactResponse.ok) {
          console.error('Subscription form submission failed:', contactResponse.statusText);
        }

        window.location.href = '/cart';
      } catch (error) {
        console.error('Error:', error);
        messagesDiv.textContent = 'An error occurred. Please try again. ' + error.message;
        messagesDiv.classList.add('error');

        submitButton.disabled = false;
        spinner.style.display = 'none';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
